export default {
  root: {
    padding: '10px 20px'
  },
  productRoot: {
    padding: '10px 0 10px 10px',
    margin: '2px 0'
  },
  label: { marginBottom: '15px' },
  dataContainer: {
    display: 'flex'
  },
  links: { cursor: 'pointer' },
  dataKey: {
    margin: '0 20px',
    width: '170px'
  },
  productDataKey: {
    margin: '0 20px',
    width: '120px'
  },
  characteristic: {
    padding: '2px 5px',
    margin: '2px 0',
    borderRadius: '3px',
    backgroundColor: '#EEF2F7'
  },
  dotsIcon: { cursor: 'pointer' },
  lookupRowValue: { display: 'flex', width: '200px', alignItems: 'center' },
  holderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '90%'
  },

  statusBox: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3px 6px',
    border: '1px solid #FFF',
    borderRadius: '10px',
    fontSize: '10px'
  },
  markerIcon: { marginLeft: '10px', fontSize: 'medium' },
  expandAllControl: {
    margin: 0,
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap'
  },
  expandAllLabel: {
    fontSize: '0.875rem',
    whiteSpace: 'nowrap'
  }
};
